// A customer quote request's stage while it's still a request (status 0, no
// WO number yet): the server's wo.quoteStage. Shown in place of "Requested".
const STAGES = {
  inProgress: { label: "Quote in Progress", className: "bg-[#EAF3FF] text-[#0058E5]" },
  proposalSent: { label: "Proposal Sent", className: "bg-[#FEF9C3] text-[#A16207]" },
  revisionRequested: { label: "Revision Requested", className: "bg-[#FDE5E5] text-[#B91C1C]" },
  approved: { label: "Quote Approved", className: "bg-[#DCFCE7] text-[#15803D]" },
};

export const quoteStageLabel = (stage) => STAGES[stage]?.label ?? null;

function QuoteStageStatus({ stage }) {
  const entry = STAGES[stage];
  if (!entry) return null;
  return (
    <div
      className={`inline-flex items-center justify-center px-[10px] py-[2px] rounded-[16px] font-OpenSansSemiBold text-[14px] leading-[20px] tracking-[0.14px] whitespace-nowrap [mix-blend-mode:multiply] ${entry.className}`}
    >
      {entry.label}
    </div>
  );
}

export default QuoteStageStatus;
